export default __webpack_public_path__ + "assets/11n.d0afc492.svg";